import ErrorBox from '@components/common/ErrorBox';
import { AccordionStepsActionTypes, AftercareActionTypes } from '@state/features/common.types';
import Button from '@stone/ui/button/Button';
import SubmitButton from '@stone/ui/button/SubmitButton';
import DwFormField from '@ui/formfield/DwFormField';
// import analytics from '@utils/analytics';
import api from '@utils/api';
import formutils from '@utils/formutils';
import createDecorator from 'final-form-focus';
import React, { useEffect, useState } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
const focusOnError = createDecorator();
const AftercareStep2 = (props) => {
    const { t } = useTranslation();
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const [errors, setErrors] = React.useState([]);
    const dispatch = useDispatch();
    useEffect(() => {
        let val = {};
        api.getForm('aftercare-service', val).then((data) => {
            setInitialValues(val);
            setFormdef(data);
        });
    }, []);
    const onSubmit = async (values) => {
        setErrors([]);
        let errors = await validate(values);
        if (errors && Object.keys(errors).length > 0) {
            return errors;
        }
        return api
            .aftercareStep2(values, formdef)
            .then((data) => {
            if (data.success) {
                dispatch({
                    type: AftercareActionTypes.UPDATE_AFTERCARE,
                    payload: values,
                });
                dispatch({
                    type: AccordionStepsActionTypes.NAVIGATE_STEP,
                    payload: 'product',
                });
            }
            if (data.error && data.error.length > 0) {
                setErrors(data.error);
            }
            if (!formutils.checkValidationAfterSubmit(data, errors)) {
                return errors;
            }
            // analytics.aftercareTwo();
        })
            .catch((e) => setErrors([e]));
    };
    const handleGoBack = () => {
        dispatch({
            type: AccordionStepsActionTypes.NAVIGATE_STEP,
            payload: 'customer',
        });
        // analytics.aftercareBackEdit('service required', 'back');
    };
    const validate = async (values) => {
        return await formutils.validateForm(values, formdef, 'aftercare-service');
    };
    if (!formdef) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "aftercare__form" },
        React.createElement(Form, { onSubmit: onSubmit, validate: validate, decorators: [focusOnError], initialValues: initialValues, render: ({ handleSubmit, form, submitting, pristine, values }) => (React.createElement("form", { onSubmit: handleSubmit },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-24" },
                        React.createElement(DwFormField, { def: formdef, name: "service", type: "radio", groupClassName: "form-group--flex" }))),
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-24" },
                        React.createElement(DwFormField, { def: formdef, name: "details", type: "textarea", helperText: t('aftercare.pleasenote') }))),
                React.createElement(ErrorBox, { errors: errors }),
                React.createElement("div", { className: "row aftercare__form-btn-container" },
                    React.createElement("div", { className: "col-lg-12" },
                        React.createElement(Button, { type: "button", cls: ['button--quaternary'], onClick: handleGoBack },
                            React.createElement(React.Fragment, null,
                                "< ",
                                t('button.back')))),
                    React.createElement("div", { className: "col-lg-12" },
                        React.createElement(SubmitButton, { submitting: submitting, label: t('aftercare.proceedtoproductidentification'), fullWidth: true }))))) })));
};
export default AftercareStep2;
